import { Component, h, Prop } from '@stencil/core';
import { Category, Producer, SocialAudit } from '../../../models/producer';
import { LANGUAGES, TRANSLATIONS } from '../../../utils';

@Component({
  tag: 'producer-content',
  styleUrl: 'producer-content.scss',
  shadow: true,
})
export class ProducerContent {
  @Prop()
  language: keyof typeof LANGUAGES = 'de';

  @Prop()
  producer?: Producer;

  @Prop()
  showProducerName = false;

  private isMobile: boolean;

  private getIcon = (category?: Category) => {
    switch (category) {
      case 'clothing':
        return <clothing-icon />;
      case 'stationery':
        return <stationery-icon />;
      case 'household':
        return <household-icon />;
      default:
        return <span />;
    }
  };

  private getProducerDetails() {
    if (this.producer === undefined) {
      return [];
    }

    const { category, street, city, country, reviewDate, employees } = this.producer;

    return [
      { title: 'productionCategory', value: TRANSLATIONS[this.language][category] },
      { title: 'street', value: street },
      { title: 'city', value: city },
      { title: 'country', value: country },
      { title: 'socialStandardsAudit', value: reviewDate },
      { title: 'numberOfEmployees', value: employees },
    ];
  }

  private getSocialAuditLogo(socialAudit: SocialAudit) {
    switch (socialAudit) {
      case 'amfori':
        return <amfori-logo />;
      case 'sedex-smeta':
        // TODO: add sedex-smeta logo
        return;
      case 'sa8000':
        // TODO: add sa8000 logo
        return;
      default:
        return;
    }
  }

  componentWillLoad() {
    this.isMobile = screen.width <= 768;
  }

  render() {
    return (
      <div class="producer-content" data-test-id="producer-content">
        {this.showProducerName && (
          <div class="producer-content__header" data-test-id={`producer-header-${this.producer?.name}`}>
            {this.producer?.name}
          </div>
        )}
        <div class="producer-content__body">
          {this.isMobile ? (
            <mdx-table-vertical>
              {this.getProducerDetails().map(({ title, value }) => (
                <mdx-table-vertical-row key={title}>
                  <div slot="row-title" data-test-id={`row-title--${title}`}>
                    {TRANSLATIONS[this.language].producer[title]}
                  </div>
                  <mdx-table-vertical-cell data-test-id={`table-data--${title}`}>
                    {title === 'productionCategory' && (
                      <span class="producer-content__wrap">
                        <span class="producer-content__wrap-icon">{this.getIcon(this.producer?.category)}</span>
                      </span>
                    )}
                    {value !== '' ? value : '-'}
                  </mdx-table-vertical-cell>
                </mdx-table-vertical-row>
              ))}
            </mdx-table-vertical>
          ) : (
            <mdx-table-horizontal>
              <mdx-table-horizontal-tbody>
                {this.getProducerDetails().map(({ title, value }) => (
                  <mdx-table-horizontal-tr key={title}>
                    <mdx-table-horizontal-th data-test-id={`row-title--${title}`}>
                      {TRANSLATIONS[this.language].producer[title]}
                    </mdx-table-horizontal-th>
                    <mdx-table-horizontal-td data-test-id={`table-data--${title}`}>
                      {title === 'productionCategory' && (
                        <span class="producer-content__wrap">
                          <span class="producer-content__wrap-icon">{this.getIcon(this.producer?.category)}</span>
                        </span>
                      )}
                      {value !== '' ? value : '-'}
                    </mdx-table-horizontal-td>
                  </mdx-table-horizontal-tr>
                ))}
              </mdx-table-horizontal-tbody>
            </mdx-table-horizontal>
          )}
          {this.getSocialAuditLogo(this.producer?.socialAudit)}
        </div>
      </div>
    );
  }
}
